/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'gatsby';

import { setDataLayer } from '../../../helpers/util';
import { CheckboxCard } from './CheckboxCard';
import FormGroup from '../../Consultation/consultationPartials/FormGroup';

const hbsptFormId = process.env.GATSBY_HUBSPOT_FORM_ID;
const hbsptPortalId = process.env.GATSBY_HUBSPOT_PORTAL_ID;

export default ({ cardsText, nameOfTheForm, location }) => {
  const [stateVals, setStateVals] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    customerNeeds: '',
    customerBudget: ''
  });
  const [submitAttempt, setSubmitAttempt] = useState(false);
  const [sending, setSending] = useState(false);
  const [, setValidationMsg] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [customerNeeds, setCustomerNeeds] = useState([]);
  const [customerBudget, setCustomerBudget] = useState('');

  const [visitedPages, setVisitedPages] = useState('');
  const [hubspotutkCookie, setHubspotutkCookie] = useState('');
  const [uri, setUri] = useState('');
  const [pageName, setPageName] = useState('');

  useEffect(() => {
    const formattedPages = localStorage
      .getItem('visited-page')
      .replace(/[\[\]"]+/g, '');
    const hutk = document.cookie.replace(
      /(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/,
      '$1'
    );
    const URI = location.href.replace(/https?:\/\//i, '');

    setHubspotutkCookie(hutk);
    setUri(URI);
    setPageName(location.pathname);

    setStateVals({
      ...stateVals,
      hubspotutkCookie: hutk,
      visitedPages: formattedPages
    });
    setSubmitSuccess(false);
    setVisitedPages(formattedPages);
  }, []);

  const handleChange = modelFieldName => e => {
    const { value } = e.target;
    setStateVals({
      ...stateVals,
      [modelFieldName]: value
    });
  };

  const setupCardData = () => {
    setStateVals({
      ...stateVals,
      customerNeeds: customerNeeds.map(el => el.name).join(),
      customerBudget
    });
  };

  useEffect(() => {
    setupCardData();
  }, []);

  useEffect(() => {
    setupCardData();
  }, [customerBudget, customerNeeds]);

  const sendDataLayer = (actionType, inputType) => {
    const data = {
      event: 'formAction',
      formName: nameOfTheForm || 'free_consultation',
      formActionType: actionType
    };

    if (inputType) {
      data.inputError = inputType;
    }

    setDataLayer(data);
  };

  const submitInitialDataLayer = () => {
    if (!isDirty) {
      sendDataLayer('start');
    }
    setIsDirty(true);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitAttempt(true);
    setSending(true);

    const formData = {
      fields: [
        {
          name: 'firstname',
          value: stateVals.name
        },
        {
          name: 'email',
          value: stateVals.email
        },
        {
          name: 'phone',
          value: stateVals.phone
        },
        {
          name: 'message',
          value: `${stateVals.message} \nHistory of user paths: ${visitedPages}`
        },
        {
          name: 'services',
          value: stateVals.customerNeeds
        },
        {
          name: 'budget',
          value: stateVals.customerBudget
        }
      ],
      context: {
        hutk: hubspotutkCookie,
        pageUri: uri,
        pageName
      }
    };
    const finalData = JSON.stringify(formData);
    const msgField = formData.fields.find(obj => obj.name === 'message');
    const messageFilled = !msgField.value.startsWith(' \nHistory');

    if (!messageFilled) {
      setValidationMsg('empty message field');
      setSending(false);
      return;
    }

    try {
      const url = `https://api.hsforms.com/submissions/v3/integration/submit/${hbsptPortalId}/${hbsptFormId}`;
      await axios
        .post(url, finalData, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(() => {
          sendDataLayer('submit_success');
          setSending(false);
          setSubmitSuccess(true);
        });
    } catch (err) {
      setSending(false);
      setValidationMsg(err.response.data);
    }
  };

  const callback = e => {
    const needs = {
      name: e.target.name,
      selected: e.target.checked
    };
    if (e.target.name == 'radio') {
      setCustomerBudget(e.target.value);
    } else {
      setCustomerNeeds(oldArr => [...oldArr, needs]);
    }
    if (!needs.selected) {
      const oldArr = customerNeeds;
      const names = oldArr.map(el => el.name);
      const indexToRemove = names.indexOf(e.target.name);
      oldArr.splice(indexToRemove, 1);
      setCustomerNeeds(oldArr);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      onChange={submitInitialDataLayer}
      autoComplete="off"
      className="contact-form"
    >
      <h2 className="mb-4 hr-line single-dash">What do you need?</h2>
      <div className="checkbox-cards">
        {cardsText.firstList.map(el => (
          <CheckboxCard key={el.id} parentCallback={callback} cardText={el} />
        ))}
      </div>
      <h2 className="mb-4 mt-5 hr-line double-dash">What is your budget?</h2>
      <div className="checkbox-cards">
        {cardsText.secondList.map(el => {
          return (
            <CheckboxCard
              key={el.id}
              type="radio"
              parentCallback={callback}
              cardText={el}
            />
          );
        })}
      </div>
      <h2 className="mb-4 mt-5 hr-line full-dash">Fill the form</h2>
      <FormGroup
        name="name"
        label="Your name"
        handleChange={handleChange}
        submitAttempt={submitAttempt}
        value={stateVals.name}
        type="input"
      />
      <FormGroup
        name="email"
        label="Email*"
        handleChange={handleChange}
        submitAttempt={submitAttempt}
        value={stateVals.email}
        type="input"
        inputType="email"
        required
      />
      <FormGroup
        name="phone"
        label="Phone"
        handleChange={handleChange}
        submitAttempt={submitAttempt}
        value={stateVals.phone}
        type="input"
      />
      <FormGroup
        name="message"
        label="Project description*"
        handleChange={handleChange}
        submitAttempt={submitAttempt}
        value={stateVals.message}
        type="textarea"
        required
      />
      <div className="row d-flex justify-content-center">
        <div className="col-12 col-sm-4">
          <div className="policy-top">
            We will contact you to discuss next steps.
          </div>
          <div className="policy-bottom mt-2">
            We are using provided by you data to serve your inquiry. For more
            information, please go to{' '}
            <Link to="/terms-of-service">Terms of Service</Link> and{' '}
            <Link to="/privacy-policy">Privacy Policy</Link>.
          </div>
        </div>
        <div className="col-12 col-sm-8">
          <button
            type="submit"
            id="submit"
            className="btn btn-main submit-btn w-100"
          >
            {sending ? (
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            ) : (
                <span >
                  {!submitSuccess ? (
                    <div id="action-beam">Get estimation</div>
                  ) : (
                      <div id="result-beam">Message sent</div>
                    )}
                </span>
              )}
          </button>
        </div>
      </div>
    </form>
  );
};
